<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Códigos'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- No Result -->
            <div v-if="!loading && (dataCode !== '' && !dataCode.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataCode.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de código ({{ dataCode.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> FUNCIONÁRIOS</th>
                        <th> VALOR</th>
                        <th> TIPO</th>
                        <th> LINK</th>
                        <th> USADO</th>
                        <th> EXPIRADO</th>
                        <th> TÍTULO</th>
                        <th> DESCRIÇÃO</th>
                        <th> DATA DE CADASTRO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataCode">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.context" target="_blank"
                               class="link">{{ c.companyName }}</a></td>
                        <td>{{ c.totalEmployee }}</td>
                        <td>{{ c.value }}</td>
                        <td>
                          <span v-if="c.paymentMethod === 0">Não Informado</span>
                          <span v-if="c.paymentMethod === 1">Boleto</span>
                          <span v-if="c.paymentMethod === 2">Cartão Crédito</span>
                          <span v-if="c.paymentMethod === 3">Dinheiro</span>
                          <span v-if="c.paymentMethod === 4">Transferência Bancaria</span>
                          <span v-if="c.paymentMethod === 10">Todos</span>
                        </td>
                        <td>
                          <a v-if="isDebug"
                             v-bind:href="'http://marqponto-site-stag.azurewebsites.net/pagamento#' + c.code + '=' + c.context + '&' + c.companyId"
                             target="_blank" class="link">marqponto/pagamento</a>
                          <a v-if="!isDebug"
                             v-bind:href="'https://marqponto.com.br/pagamento#' + c.code + '=' + c.context  + '&' + c.companyId"
                             target="_blank" class="link">marqponto/pagamento</a>
                        </td>
                        <td>
                          <span v-if="c.isUsed">SIM</span>
                          <span v-else>NÃO</span>
                        </td>
                        <td>
                          <span v-if="c.isExpired">SIM</span>
                          <span v-else>NÃO</span>
                        </td>
                        <td>{{ c.title }}</td>
                        <td>{{ c.description }}</td>
                        <td>{{ c.createdAt | formatDate }}</td>
                        <td>
                          <a v-on:click="disableCode(c)" title="Desativar" class="btn-to-delete">
                            <i class="fa fa-ban" aria-hidden="true"></i> Desativar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  CODE_SUB,
  IS_DEBUG,
  DELETE_CODE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "code-subscription",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      isDebug: IS_DEBUG,
      loading: false,
      dataCode: ""
    }
  },
  methods: {
    deleteCode(data) {
      this.loading = true;
      REQUEST_SERVICE.delete(DELETE_CODE + data.code + "/" + data.context).then((response) => {
        UTIL_SERVICE.console("RESULT DELETE_CODE:", response.data);

        swal("Aviso", response.data, "success");
        this.searchCode();
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    disableCode(data) {
      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja desativar o código: \n" + data.title,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            this.deleteCode(data);
          }
        });
    },
    searchCode() {
      this.loading = true;

      REQUEST_SERVICE.get(CODE_SUB + "?t=kkkk").then((response) => {
        UTIL_SERVICE.console("RESULT CODE_SUB:", response.data);

        this.dataCode = response.data;
        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.isDebug = IS_DEBUG;

    this.searchCode();
  }
}
</script>

<style lang="scss">
.link {
  color: #3598dc;
  border-bottom: 1px solid #3598dc;
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    font-weight: 600;
    text-decoration: none;
    color: #0F77AE;
    border-bottom: 1px dashed #0F77AE;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/codeSubscription/codeSubscription.vue